import { Box } from "@mui/material";
import { memo, useMemo } from "react";
import { PreLiquidacionInfoProfesional } from "./PreLiquidacionInfoProfesional";
import { GrillaLiquidacionesPaciente } from "./GrillaLiquidacionesPaciente";

const PreLiquidacionGrillaPorProfesionalBase = ({
    idProfesional,
    liquidaciones,
    profesionalData,
    columns,
    mesLiquidado,
    allowedWrite,
    seleccionadosProfesional,   // Set específico de este profesional
    seleccionarTodos
}) => {
    const totalValue = useMemo(
        () => liquidaciones.reduce((total, l) => total + (l?.liquidacionTotal || 0), 0),
        [liquidaciones]
    );

    return (
        <Box>
            <Box sx={{ mb: 2 }}>
                <PreLiquidacionInfoProfesional
                    profesional={profesionalData}
                    mesLiquidado={mesLiquidado}
                    observacionRechazo={profesionalData.observacionRechazo}
                    liquidacionMesAnterior={liquidaciones[0]?.liquidacionTotalMesAnterior}
                />
            </Box>

            <GrillaLiquidacionesPaciente
                columns={columns}
                rows={liquidaciones}
                totalValue={totalValue}
                totalLabel='Total'
            />
        </Box>
    );
};

export const PreLiquidacionGrillaPorProfesional = memo(PreLiquidacionGrillaPorProfesionalBase);